export const formatIndianDate = (dateStr) => {
    if (!dateStr) return "-";

    const date = new Date(dateStr);

    const day = String(date.getDate()).padStart(2, "0");
    const month = date.toLocaleString("en-IN", { month: "short" }); // Jan, Feb, Mar
    const year = date.getFullYear();
    return `${day}-${month}-${year} `;
};
